module.exports = __webpack_public_path__ + "static/media/book.826a9e5c.svg";